<template>

    <operario-form :idBusiness="idBusiness" :pag="pag" :idOperario="idOperario"></operario-form>

</template>

<script>
    import OperarioForm from '../../../Widgets/Operarios/OperarioForm.vue'
    import swal from 'sweetalert2'
    export default {
        components: {
            OperarioForm
        },
        data() {
            return {
                idBusiness: this.$route.params.idBusiness,
                idOperario: this.$route.params.idOperario,
                pag: this.$route.params.pag,
            }
        },
        created() {


            let action = this.idOperario ? this.$i18n.t("editar") : this.$i18n.t("nuevo");
            this.$store.dispatch('setNameRoute', action +' '+this.$i18n.t("operario"));

            this.getRestrictions();
        },
        methods: {

            getRestrictions() {

                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                        idBusiness: this.idBusiness,
                        idRestriction: 17,
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getRestrictionsByTipo", config)
                    .then(function (response) {

                        if (!response.data.response) {

                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                            vm.$router.push({
                                name: 'configuracion'
                            })

                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });


            }


        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/Operarios/Operario.vue